/**
 * 【一時対応】開発時は `mise run site-embed:dev` の静的配信（既定 `http://localhost:5173/dist/iife.js`）を参照している。
 * 【通常想定】ローカル環境でも本番同様に **dev-cdn**（`https://dev-cdn.chillnn.com/site-embed/latest/iife.js`）を使う形に戻す。
 */

/** IA-host の埋め込みプレビュー（iframe）由来。CloudFront の cs_uri_query 用 */
const PREVIEW_QUERY = "preview=1";

function withPreviewQuery(url: string): string {
	if (url.includes(PREVIEW_QUERY)) {
		return url;
	}
	const sep = url.includes("?") ? "&" : "?";
	return `${url}${sep}${PREVIEW_QUERY}`;
}

/**
 * サイト埋め込み IIFE の URL（環境に応じて切り替え）
 * - 開発（一時）: 上記ファイル頭コメントのとおりローカル serve
 * - 本番ビルド: `VITE_STAGE` に応じて cdn / dev-cdn
 */
export function getSiteEmbedIifeUrl(): string {
	// ローカルを参照したい場合は 以下をコメントイン
	// return "http://localhost:5173/dist/iife.js";
	return import.meta.env.VITE_STAGE === "prd"
		? "https://cdn.chillnn.com/site-embed/latest/iife.js"
		: "https://dev-cdn.chillnn.com/site-embed/latest/iife.js";
}

/**
 * 管理画面の iframe プレビュー専用。
 * 既定は `getSiteEmbedIifeUrl` に `preview=1` を付与（ログでプレビュー取得と判別するため）。`VITE_SITE_EMBED_IIFE_PREVIEW_URL` で上書きした場合は付与しない。
 */
export function getSiteEmbedIifePreviewUrl(): string {
	const override = import.meta.env.VITE_SITE_EMBED_IIFE_PREVIEW_URL?.trim();
	if (override) {
		return override;
	}
	return withPreviewQuery(getSiteEmbedIifeUrl());
}
